import { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Grid,
  Button,
} from "@material-ui/core";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import InputText from "components/_refactor/text/input";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";
import { Close } from "@mui/icons-material";

const exportTypes = [
  {
    Nome: "Download",
    id: "Download",
  },
  {
    Nome: "E-mail",
    id: "E-mail",
  },
  {
    Nome: "Whatsapp",
    id: "Whatsapp",
  },
];

export default function DialogExport({ onClose, titles }) {
  const [loading, setLoading] = useState(false);
  const [exportType, setExportType] = useState(exportTypes[0]);
  const [email, setEmail] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [subject, setSubject] = useState("");
  const [emailError, setEmailError] = useState("");
  const [whatsappError, setWhatsappError] = useState("");

  const snackbar = useSnackbar();

  useEffect(() => {
    if (exportType.id === "E-mail") {
      if (email === "") {
        setEmailError("");
      } else if (!MaskAndValid.validateEmail(email)) {
        setEmailError("E-mail inválido");
      } else {
        setEmailError("");
      }
    } else {
      setEmailError("");
    }
  }, [email, exportType]);

  useEffect(() => {
    if (exportType.id === "Whatsapp") {
      if (whatsapp === "") {
        setWhatsappError("");
      } else if (!MaskAndValid.validatePhone(whatsapp)) {
        setWhatsappError("Telefone inválido. Use o formato (XX) XXXXX-XXXX");
      } else {
        setWhatsappError("");
      }
    } else {
      setWhatsappError("");
    }
  }, [whatsapp, exportType]);

  const handleExport = () => {
    if (exportType.id === "E-mail") {
      if (MaskAndValid.isNullOrEmpty(email)) {
        setEmailError("E-mail é obrigatório");
        return;
      }
      if (!MaskAndValid.validateEmail(email)) {
        setEmailError("E-mail inválido");
        return;
      }
      if (MaskAndValid.isNullOrEmpty(subject)) {
        return;
      }
      exportByEmail(email, subject);
    } else if (exportType.id === "Whatsapp") {
      if (MaskAndValid.isNullOrEmpty(whatsapp)) {
        setWhatsappError("WhatsApp é obrigatório");
        return;
      }
      if (!MaskAndValid.validatePhone(whatsapp)) {
        setWhatsappError("Telefone inválido. Use o formato (XX) XXXXX-XXXX");
        return;
      }
      exportByWhatsapp(whatsapp);
    } else {
      exportByDownload();
    }
  };

  const exportByEmail = async () => {
    setLoading(true);
    try {
      const response = await Api.get(
        "send-email-list-financial-docs",
        "financialdocument",
        "?numerosTitulos=" +
          titles.map((title) => title.NumeroTitulo).join(",") +
          "&email=" +
          email +
          "&assunto=" +
          subject,
        true
      );
      if (response.Success) {
        snackbar.showMessage("Boletos exportados por e-mail!", {
          severity: "success",
        });
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
      });
    } finally {
      setLoading(false);
      onClose();
    }
  };
  const exportByWhatsapp = (whatsapp) => {
    setLoading(true);
    const url =
      encodeURI(
        `https://api.whatsapp.com/send?phone=${
          "55" + whatsapp?.replace(/\D/g, "")
        }&text=Aqui está a lista de boletos dos títulos selecionados do *Portal Karsten* para download:
            `
      ) +
      titles.map((title) =>
        encodeURIComponent(`
Boleto do Título Financeiro nº ${title.NumeroTitulo}: ${title.UrlDownloadBoleto}
                `)
      ).join(`
            `);

    window.open(url, "_blank");
    setLoading(false);
  };

  const exportByDownload = async () => {
    try {
      setLoading(true);
      const response = await Api.get(
        "batch-download-financial-docs",
        "financialdocument",
        "?numerosTitulos=" + titles.map((title) => title?.NumeroTitulo),
        true
      );
      if (response.Success) {
        window.open(response.Result, "_blank");
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
      });
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth="md">
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            Exportar Boletos
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <AutoCompleteField
              label="Selecione a forma que deseja exportar os boletos selecionados:"
              options={exportTypes}
              value={exportType}
              onChange={(value) => setExportType(value)}
            />
          </Grid>
          {exportType.id === "E-mail" && (
            <>
              <Grid item xs={12}>
                <InputText
                  label="E-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  required
                  error={!!emailError}
                  errorMessage={emailError}
                />
              </Grid>
              <Grid item xs={12}>
                <InputText
                  label="Assunto"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                />
              </Grid>
            </>
          )}
          {exportType.id === "Whatsapp" && (
            <Grid item xs={12}>
              <InputText
                label="Whatsapp"
                value={whatsapp}
                onChange={(e) =>
                  setWhatsapp(MaskAndValid.maskPhone(e.target.value))
                }
                required
                error={!!whatsappError}
                errorMessage={whatsappError}
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">
          Cancelar
        </Button>
        <Button onClick={handleExport} variant="contained" disabled={loading}>
          Exportar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
